import type { ReactNode } from 'react';
import { useCallback, useState } from 'react';
import type { OfferFormState, OfferTypesType } from '../types/offer.types';
import { OfferFormContext } from './OfferFormContext';

interface OfferFormProviderProps {
  children: ReactNode;
  initialOfferType?: OfferTypesType;
  initialForm?: OfferFormState;
}

const DEFAULT_FORM_STATE: OfferFormState = {
  offer_type: null,
  offer_price: null,
  percentage_discount: null,
  from: null,
  to: null,
  buy_quantity: null,
  pay_quantity: null,
  unit_buy: null,
  minimum_quantity: null,
  price_per_unit: null,
};

export const OfferFormProvider = ({ children, initialOfferType = null, initialForm = DEFAULT_FORM_STATE }: OfferFormProviderProps) => {
  const [offerType, setOfferType] = useState<OfferTypesType>(initialOfferType);
  const [offerForm, setOfferForm] = useState<OfferFormState>(initialForm);

  const resetForm = useCallback(() => {
    setOfferType(null);
    setOfferForm(DEFAULT_FORM_STATE);
  }, []);

  const value = {
    offerType,
    offerForm,
    setOfferType,
    setOfferForm,
    resetForm,
  };

  return <OfferFormContext.Provider value={value}>{children}</OfferFormContext.Provider>;
};
